/** @jsxImportSource @emotion/react */
import { useMemo } from 'react'
import Chip, { ChipProps } from 'components/Chip'
import { Box, Text } from 'grommet'

import { BasicEmotion, Emotion } from 'db-tables'
import angleToColor from 'util/angleToColor'

import EmotionName from './EmotionName'
import { emotionDropProps } from './tooltip'
import EmotionDescription from './EmotionDescription'

type Props = {
  emotion: BasicEmotion | Emotion
  angle: number
  height?: string
  count?: number
} & Pick<ChipProps, 'showCloseIcon' | 'onClick' | 'fill'>

export default function EmotionChip({ emotion, angle, count, height, ...rest }: Props) {
  const color = useMemo(() => angleToColor(angle), [angle])

  return (
    <Chip
      key={emotion.id}
      chipColor={color}
      css={{ paddingRight: count && count > 1 ? '.25rem' : '.5rem', height }}
      label={
        <Box direction="row" fill="horizontal">
          <Box fill="horizontal">
            <Text size="small" textAlign="center" css={{ flexGrow: 1 }}>
              <EmotionName emotion={emotion} />
            </Text>
          </Box>
          {count && count > 1 && (
            <Box
              key={emotion.id}
              round="small"
              background={{ color: 'white', opacity: 'strong' }}
              width={{ min: 'fit-content' }}
              pad={{ horizontal: 'xsmall' }}
              margin={{ left: 'xsmall' }}>
              <Text size="small" textAlign="center" color="black">
                {count}
              </Text>
            </Box>
          )}
        </Box>
      }
      showCloseIcon={rest.showCloseIcon}
      tip={{
        plain: true,
        dropProps: emotionDropProps,
        content: (
          <Box width={{ max: 'medium' }} margin="small">
            <Text size="small" textAlign="start">
              <EmotionDescription emotion={emotion} />
            </Text>
          </Box>
        ),
      }}
      {...rest}
    />
  )
}
